import { render, staticRenderFns } from "./FoodTests.vue?vue&type=template&id=e7d2dbc2&"
import script from "./FoodTests.vue?vue&type=script&lang=js&"
export * from "./FoodTests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports